import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { LoanData } from '../types/loan';
import { LoanListRequest } from '../types/request/loan';
import { LoanService } from '../Apis/LoanServices';

interface LoanRequestActionState {
  page: number;
  totalItems: number;
  pageSize: number;
  loading: boolean;
  loans: LoanData[];
  error: string | null;
}

export const fetchLoanList = createAsyncThunk(
  'loans/fetchLoans',
  async (request: Partial<LoanListRequest>) => {
    return await LoanService.getLoanList(request);
  }
);

const initialState: LoanRequestActionState = {
  loading: false,
  page: 0,
  totalItems: 0,
  pageSize: 0,
  loans: [],
  error: null,
};

const loanRequestSlice = createSlice({
  name: 'loanaction',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchLoanList.pending, state => {
        state.loading = true;
      })
      .addCase(fetchLoanList.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = mapLoanToLoanViewModels(action.payload.records);
        state.page = action.payload.pageNumber;
        state.pageSize = action.payload.numberOfItems;
        state.totalItems = action.payload.totalItems;
      })
      .addCase(fetchLoanList.rejected, state => {
        state.loading = false;
      });
  },
});
export default loanRequestSlice;

export const loanRequestSelector = (state: RootState) =>
  state.loanRequestAction;
function mapLoanToLoanViewModels(leaves?: LoanData[]): LoanData[] {
  const viewModels: LoanData[] = leaves?.map(item => {
    const viewModel: LoanData = {
      loanId: item.loanId,
      loanMaster: { ...item.loanMaster },
      lmsVariables: { ...item.lmsVariables },
      loanPdcDetails: { ...item.loanPdcDetails },
      loanOutstandingDetails: { ...item.loanOutstandingDetails },
      loanTransactions: { ...item.loanTransactions },
      customerDetails: item.customerDetails,
      metaDataLoanAllocationDto: item.metaDataLoanAllocationDto,
    };
    return viewModel;
  });

  return viewModels ?? [];
}
